import { adminConstants } from '../constant/admin-constant';

let userAdmin = JSON.parse(localStorage.getItem('admin-user'));
const initialState = userAdmin ? { loggedIn:true, adminType: userAdmin.type, userAdmin:userAdmin, loading:false, dashboardCount:''} : { loggedIn:false, adminType: '', userAdmin:'', loading:false };

export function adminReducer(state = initialState, action){
	
	switch(action.type){
		case adminConstants.LOGIN_ADMIN_REQUEST:
			return { ...state, loading:true };
		case adminConstants.LOGIN_ADMIN_SUCCESS:
			if(action.payload.type === 'admin'){
				return { ...state, loading:false, userAdmin : action.payload, adminType:'admin', loggedIn:true };
			}
			else if (action.payload.type === 'company'){
				return { ...state, loading:false, userAdmin : action.payload, adminType:'company', loggedIn:true };
			}
			return {...state, loading:false, userAdmin:'',adminType:'', loggedIn:false};
		case adminConstants.LOGIN_ADMIN_FAILURE:
			return { loading:false };
		
		case adminConstants.LOGOUT_ADMIN:
			return {};

		case adminConstants.GET_DASHBOARD_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_DASHBOARD_SUCCESS:
			return { ...state, loading:false, dashboardCount : action.payload.dashboardCount };
		case adminConstants.GET_DASHBOARD_FAILURE:
			return { loading:false, error : action.payload };


		// case adminConstants.GET_ADMIN_USERS_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.GET_ADMIN_USERS_SUCCESS:
		// 	return { ...state, loading:false, adminUsers : action.payload.adminUsers };
		// case adminConstants.GET_ADMIN_USERS_FAILURE:
		// 	return { loading:false, error : action.payload };

		// case adminConstants.GET_ADMIN_USER_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.GET_ADMIN_USER_SUCCESS:
		// 	return { ...state, loading:false , editAdminUser:action.payload};
		// case adminConstants.GET_ADMIN_USER_FAILURE:
		// 	return { loading:false, error : action.payload };

		// case adminConstants.EDIT_ADMIN_USER_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.EDIT_ADMIN_USER_SUCCESS:
		// 	return { ...state, loading:false , editAdminUser:action.payload};
		// case adminConstants.EDIT_ADMIN_USER_FAILURE:
		// 	return { loading:false, error : action.payload };

		// case adminConstants.STORE_ADMIN_USER_REQUEST:
		// 	return { ...state, loading:true }
		// case adminConstants.STORE_ADMIN_USER_SUCCESS:
		// 	return { ...state, loading:false, editAdminUser:'' };
		// case adminConstants.STORE_ADMIN_USER_FAILURE:
		// 	return { ...state, loading:false, error:action.payload };

		// case adminConstants.DELETE_ADMIN_USER_REQUEST:
		// 	return { ...state, loading:true }
		// case adminConstants.DELETE_ADMIN_USER_SUCCESS:
		// 	return { ...state, loading:false, editAdminUser:'' };
		// case adminConstants.DELETE_ADMIN_USER_FAILURE:
		// 	return { loading:false, error:action.payload };
			
		case adminConstants.CHECK_USER_PERMISSIONS_REQUEST:
			return { ...state, loading:true };
		case adminConstants.CHECK_USER_PERMISSIONS_SUCCESS:
			if(action.payload.type === 'admin'){
				return { ...state, loading:false, userAdmin : action.payload, adminType:'admin', loggedIn:true };
			}
			else if (action.payload.type === 'company'){
				return { ...state, loading:false, userAdmin : action.payload, adminType:'company', loggedIn:true };
			}
			return {...state, loading:false, userAdmin:'',adminType:'', loggedIn:false};
		case adminConstants.CHECK_USER_PERMISSIONS_FAILURE:
			return { loading:false, error : action.payload };

		default:

			return {...state};
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/AdminReducer.jsx